import 'styled-components/macro';

import {
  kioskThemeCustomizationSchema,
  kioskThemeCustomizationUiSchema,
} from '../../../../../components/JsonEditor/constants/ThemeSchema/kioskThemeCustomization';

import CustomizeTheme from '../../../../../components/CustomizeTheme';
import { CustomizeThemeLocalizationEntityLevel } from '../../../../../enums/CustomizeThemeLocalizationEntityLevel';
import React from 'react';
import { ThemeComponentName } from '../../../../../enums/ComponentNameEnum';
import { useParams } from 'react-router-dom';

const CustomizeKioskTheme: React.FC<{}> = () => {
  const { tenantId } = useParams<{ tenantId: string }>();

  return (
    <CustomizeTheme
      schema={kioskThemeCustomizationSchema}
      uiSchema={kioskThemeCustomizationUiSchema}
      componentName={ThemeComponentName.KIOSK}
      fileNameToDownloadDefaultJson={`Default Kiosk theme - Tenant ${tenantId}.json`}
      fileNameToDownloadCurrentJson={`Current Kiosk theme - Tenant ${tenantId}.json`}
      title="Customize kiosk theme"
      entityLevel={CustomizeThemeLocalizationEntityLevel.TENANT}
      entityId={tenantId}
    />
  );
};

export default CustomizeKioskTheme;
